import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { OddLifecyclePanel } from './OddLifecyclePanel';
import { OutcomeHealthPanel } from './OutcomeHealthPanel';
import { OutcomeListPanel } from './OutcomeListPanel';
import { WorkflowLaunchPanel } from './WorkflowLaunchPanel';
import { MethodologyPanel } from './MethodologyPanel';

/**
 * ODD Sidebar for Outcomes routes
 *
 * Renders only when pathname.startsWith('/outcomes')
 * Provides operator context:
 * - Current delivery phase
 * - Outcome health metrics
 * - Filterable outcome list
 * - Quick-launch ODD workflow actions
 * - ODD methodology reference
 */
export function OutcomesSidebar(): React.ReactElement {
  return (
    <aside className="w-60 border-r border-border bg-surface">
      <ScrollArea className="h-full">
        <div className="flex flex-col gap-0">
          {/* Delivery Lifecycle Phase */}
          <div className="px-4 py-3">
            <OddLifecyclePanel />
          </div>
          <Separator />

          {/* Outcome Health Metrics */}
          <div className="px-4 py-3">
            <OutcomeHealthPanel />
          </div>
          <Separator />

          {/* Outcome List */}
          <div className="flex flex-1 flex-col px-4 py-3">
            <OutcomeListPanel />
          </div>
          <Separator />

          {/* ODD Actions */}
          <div className="px-4 py-3">
            <WorkflowLaunchPanel />
          </div>
          <Separator />

          {/* ODD Methodology Reference */}
          <div className="px-4 py-3">
            <MethodologyPanel />
          </div>

          {/* Bottom padding */}
          <div className="h-4" />
        </div>
      </ScrollArea>
    </aside>
  );
}
